<template>
  <el-dialog
    v-if="model"
    :title="model.title | uppercase"
    :visible.sync="isVisible"
    :width="model.width"
    append-to-body
    :class="['dialog-confirm', model.classes]"
    @close="clickHandler('cancel')">
    <div class="confirm-content">
      <div v-html="content"></div>
    </div>
    <div slot="footer" class="dialog-footer confirm-footer">
      <slot name="footer-confirm" :model="model" :clickHandler="clickHandler">
        <button
          type="button"
          class="btn btn-control btn-border grey btn-size-s"
          @click.prevent="clickHandler('cancel')">
          {{model.titleButtonCancel}}
        </button>
        <button
          type="button"
          class="btn btn-control btn-control-delete btn-border btn-size-s"
          ref="btnConfirm"
          @click.prevent="clickHandler('confirm')">
          <i class="el-icon-delete"></i>
          {{model.titleButtonConfirm}}
        </button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Confirm',
  props: { config: { type: Object } },
  data () {
    return {
      isVisible: false,
      model: null,
      data: null,
      callback: null
    }
  },
  watch: {
    config: {
      immediate: true,
      handler () {
        this.model = this.parseJsTemplate(Object.assign(this.MODEL(), this.config))
      }
    }
  },
  computed: {
    content () {
      if (this.model.msgTemplate && this.data) {
        return this.model.msgTemplate(this.data, this.$root)
      } else if (this.model.msgDataKey && this.data) {
        return this.model.text.replace(/("{.}")/gi, `<strong>${this.data[this.model.msgDataKey]}</strong>`)
      } else {
        return this.model.text
      }
    }
  },
  methods: {
    MODEL () {
      return {
        title: this.L10n('delete'),
        text: this.L10n('delete-item'),
        msgTemplate: null,
        msgDataKey: null,
        titleButtonConfirm: this.L10n('delete'),
        titleButtonCancel: this.L10n('cancel'),
        classes: '',
        width: '60rem'
      }
    },
    show (data, callback) {
      this.data = data
      this.callback = callback
      this.isVisible = true
      this.$nextTick(() => this.$refs.btnConfirm && this.$refs.btnConfirm.focus())
    },
    hide () {
      this.isVisible = false
    },
    clickHandler (command) {
      this.$emit(command, this.data, this.callback)
      this.hide()
    }
  }
}
</script>
<style lang="stylus">
  .confirm-footer {
    &>button{
      margin 0 .4rem
    }
  }
</style>
